import { requestService } from '../services/requestService';

export function normalizePhoneDigits(phone: string | null | undefined): string {
  return (phone || '').replace(/\D/g, '');
}

export function formatRequestDateTime(dateStr: string | null | undefined): { date: string; time: string } {
  if (!dateStr) return { date: '-', time: '' };
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return { date: '-', time: '' };
  return {
    date: d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }),
    time: d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
  };
}

export function appendMobileFilters(
  params: Record<string, unknown>,
  mobileNumber: string
): void {
  const digits = normalizePhoneDigits(mobileNumber);
  if (!digits) return;

  params['filters[$or][0][phoneNumber][$contains]'] = digits;
  params['filters[$or][1][insuranceClient][phoneNumber][$contains]'] = digits;
  params['filters[$or][2][customer][phone][$contains]'] = digits;
  params['filters[$or][3][customer][mobile][$contains]'] = digits;
}

export async function findInsuranceClientIdsByServiceNumber(
  serviceNumber: string
): Promise<number[]> {
  const term = serviceNumber.trim();
  if (!term) return [];

  const response = await requestService.getAll({
    'filters[requestNumber][$containsi]': term,
    'pagination[pageSize]': 100,
    sort: 'createdAt:desc',
    'populate[insuranceClient]': 'id',
  });

  const ids = new Set<number>();
  for (const req of response.data || []) {
    const attrs = req.attributes || req;
    const ic = attrs.insuranceClient;
    const id = ic?.data?.id ?? ic?.id ?? (typeof ic === 'number' ? ic : null);
    if (id) ids.add(Number(id));
  }
  return Array.from(ids);
}

export async function findCustomerIdsByServiceNumber(serviceNumber: string): Promise<number[]> {
  const term = serviceNumber.trim();
  if (!term) return [];

  const response = await requestService.getAll({
    'filters[requestNumber][$containsi]': term,
    'pagination[pageSize]': 100,
    sort: 'createdAt:desc',
    'populate[customer]': 'id',
  });

  const ids = new Set<number>();
  for (const req of response.data || []) {
    const attrs = req.attributes || req;
    const customer = attrs.customer;
    const id = customer?.data?.id ?? customer?.id ?? (typeof customer === 'number' ? customer : null);
    if (id) ids.add(Number(id));
  }
  return Array.from(ids);
}

export async function findPhonesByServiceNumber(serviceNumber: string): Promise<string[]> {
  const term = serviceNumber.trim();
  if (!term) return [];

  const response = await requestService.getAll({
    'filters[requestNumber][$containsi]': term,
    'pagination[pageSize]': 50,
    sort: 'createdAt:desc',
  });

  const phones = new Set<string>();
  for (const req of response.data || []) {
    const attrs = req.attributes || req;
    const digits = normalizePhoneDigits(attrs.phoneNumber);
    if (digits) phones.add(digits);
  }
  return Array.from(phones);
}

export function appendIdInFilter(
  params: Record<string, unknown>,
  ids: number[],
  field = 'id'
): void {
  ids.forEach((id, index) => {
    params[`filters[${field}][$in][${index}]`] = id;
  });
}
